export const BreakdownType = {
  LOCATION: 'Location',
  KEYWORD: 'Keyword',
  SEARCH_TERM: 'Search Term',
};
